export default __webpack_public_path__ + "static/huangbin-087c15fb6d695a011cf9714766fa83f1.jpg";